export default "__VITE_PUBLIC_ASSET__139fb94d__"